import React, { useEffect, useState } from "react";
import ViewTable from "../../../Components/Common/ViewTable";
import { get, post, put, del, api } from "../../../utils/api";
import Cards from "../../../Components/Common/Cards";
import FilterModal from "../../../Components/Common/FilterModal";
import ActionButtons from "../../../Components/Common/ActionButtons";
import ViewData from "./ViewData";
import Form from "./Form";
import { Alert, Snackbar } from "@mui/material";
import BulkUploadModal from "../../../Components/Common/BulkUploadModal";
import BulkUploadSkippedDialog from "../../../Components/Common/BulkUploadSkippedDialog";
import DeleteAlertDialog from "../../../Components/Masters/DeleteAlertDialog";
import BulkUploadReview from "./BulkUploadReview";
import { useUser } from "../../../context/AuthContext";

const UseOfSoldProducts = () => {
  const { user } = useUser();
  const isMongoId = (value) =>
    typeof value === "string" && /^[a-f\d]{24}$/i.test(value);
  const [sortConfig, setSortConfig] = useState({ key: "createdAt", direction: "desc" });
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [deletedItemId, setDeletedItemId] = useState("");
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);
  const [bulkUploadTable, setBulkUploadTable] = useState(false);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState([]);
  const [matchData, setMatchData] = useState([]);
  const [skippedUploadDialog, setSkippedUploadDialog] = useState({
    open: false,
    skippedEntries: [],
    inserted: 0,
    skipped: 0,
  });

  const [filters, setFilters] = useState({
    productCategory: [],
    productName: [],
  });

  const [cardData, setCardData] = useState({
    totalProducts: 0,
    totalUnitsOfProductSold: 0,
    highestUnitOfProductSold: null,
    totalEnergyConsumedInUsePhase: 0,
    totalEnergyOrFuelUsedForMaintenance: 0,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [masterProducts, setMasterProducts] = useState([]);
  const [productSearchTerm, setProductSearchTerm] = useState("");

  const headers = [
    { key: "createdAt", label: "Date", sortable: true },
    { key: "productName", label: "Product Name", sortable: true },
    { key: "productIdOrSku", label: "Product ID / SKU", sortable: true },
    { key: "unitOfProductSold", label: "Unit of Product Sold", sortable: true },
    { key: "dateOfSale", label: "Date of Sale", sortable: true },
  ];

  const inputData = [
    { fieldName: "productName", title: "Product Name" },
    { fieldName: "productIdOrSku", title: "Product ID / SKU" },
    { fieldName: "productDescription", title: "Product Description" },
    { fieldName: "dateOfSale", title: "Date of Sale" },
    { fieldName: "unitOfProductSold", title: "Unit of Product Sold" },
    // {
    //   fieldName: "expectedLifetimeOfTheProductYears",
    //   title: "Expected Lifetime of the Product (years)",
    // },

    // {fileType:"Energy Type Required for Use", title: "Energy Type Required for Use" },
    {
      fieldName: "avgAnnualEnergyConsumptionPerUnit",
      title: "Average Annual Energy Consumption per Unit",
    },

    {
      fieldName: "typeOfMaintenanceRequired",
      title: "Type of Maintenance Required",
    },

    // { fieldName: "fuelType", title: "Fuel Name" },

    // {
    //   fieldName: "frequencyOfMaintenancePerYear",
    //   title: "Frequency of Maintenance per year",
    // },

    // {
    //   fieldName: "energyTypeRequiredForUse",
    //   title: "Energy Type Required for Use",
    // },

    {
      fieldName: "recyclableComponentsPercentage",
      title: "Recyclable Components (%)",
    },

    // {
    //   fieldName: "averageDisposalMethodByCustomers",
    //   title: "Average Disposal Method by Customers",
    // },

    {
      fieldName: "typicalOperatingHours",
      title: "Typical Operating Hours per Day / Week / Year",
    },

    // { fieldName: "fuelConsumption", title: "Fuel Quantity" },
    // { fieldName: "fuelConsumptionUnit", title: "Fuel Unit" },

    {
      fieldName: "energyOrFuelUsedForMaintenance",
      title: "Energy or Fuel Used for Maintenance",
    },

  ];

  const filterData = [
    { title: "Date of Sale", type: "date", key: "dateOfSale", value: [] },
    // {
    //   title: "Product Category",
    //   type: "option",
    //   key: "productCategory",
    //   value: filters?.productCategory || [],
    // },
    // {
    //   title: "Product Name",
    //   type: "option",
    //   key: "productName",
    //   value: filters?.productName || [],
    // },
  ];

  const fetchData = async () => {
    try {
      const filter = { ...filterObj };

      if (filter.dateOfSale) {
        filter.startDate = filter?.dateOfSale?.start;
        filter.endDate = filter?.dateOfSale?.end || new Date();
      }

      const queryParams = new URLSearchParams({
        ...filter,
        page: currentPage,
        limit: 10,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
      }).toString();

      const res = await get(`/scope3/useOfSoldProducts/get?${queryParams}`);

      const arr =
        res?.data?.data?.map((item) => ({
          productName: item?.productName,
          productIdOrSku: item?.productIdOrSku,
          productCategory: item?.productCategory,
          unitOfProductSold: item?.unitOfProductSold || null,
          dateOfSale: item?.dateOfSale,
          action: "View",
          id: item?._id,
          ...item,
        })) || [];

      setTableData(arr);
      setTotalPages(res?.data?.totalPages || 1);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [sortConfig, filterObj, currentPage]);

  const fetchCardData = async () => {
    try {
      const res = await get(`/scope3/useOfSoldProducts/cardData`);
      const data = res?.data?.data || {};
      setCardData({
        totalProducts: data?.totalProducts || 0,
        totalUnitsOfProductSold: data?.totalUnitsOfProductSold || 0,
        highestUnitOfProductSold: data?.highestUnitOfProductSold || null,
        totalEnergyConsumedInUsePhase: data?.totalEnergyConsumedInUsePhase || 0,
        totalEnergyOrFuelUsedForMaintenance: data?.totalEnergyOrFuelUsedForMaintenance || 0,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const fetchFilters = async () => {
    try {
      const res = await get(`/scope3/useOfSoldProducts/filter`);
      const { productCategory, productName } = res?.data?.data || {};

      setFilters({
        productCategory: productCategory || [],
        productName: productName || [],
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, []);

  useEffect(() => {
    fetchExcelData();
  }, []);

  useEffect(() => {
    fetchFilters();
  }, []);

  const uploadErrorClose = () => {
    setBulkUploadModal(false);
    setBulkUploadTable(true);
  };

  const formatHighestUnitOfProductSold = (highestProduct) => {
    if (!highestProduct) return "0";

    const productName = highestProduct?.productName || "N/A";
    const productId = highestProduct?.productIdOrSku
      ? ` (${highestProduct.productIdOrSku})`
      : "";
    const value = highestProduct?.totalUnitsOfProductSold ?? 0;
    const unit = highestProduct?.unit ? ` ${highestProduct.unit}` : "";

    return `${productName}${productId}: ${value}`;
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    setBulkUploadTable(false);
    setMatchData([]);
    setFormDataBulkUpload([]);
    fetchData();
    fetchCardData();
  };

  const bannerData = [
    {
      title: "Total number of products",
      description: `${cardData?.totalProducts ?? 0}`,
    },
    {
      title: "Total units of product sold",
      description: `${cardData?.totalUnitsOfProductSold ?? 0}`,
    },
    {
      title: "Highest Unit of product sold ",
      description: formatHighestUnitOfProductSold(cardData?.highestUnitOfProductSold),
    },
    // {
    //   title: "Total energy consumed in use phase",
    //   description: `${cardData?.totalEnergyConsumedInUsePhase ?? 0}`,
    // },
    // {
    //   title: "Total Energy or Fuel Used for Maintenance",
    //   description: `${cardData?.totalEnergyOrFuelUsedForMaintenance ?? 0}`,
    // },
  ];

  const handleSort = (key, direction) => {
    setSortConfig({ key, direction });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
    setCurrentPage(1);
  };



  const fetchExcelData = async () => {
    await get("/master/product/productsList")
      .then((res) => {
        let data = res.data.data;
        let arr = data.map((el, idx) => {
          return {
            "Product Name": el?.productName,
            "Product ID / SKU": el?.productId,
            "Date of Sale (DD/MM/YYYY)": "",
            "Unit of Product Sold (Quantity MT)": "",
            // "Average Annual Energy Consumption per Unit": "",
            // "Typical Operating Hours per Day / Week / Year": "",
            "Type of Maintenance Required": "",
            "Recyclable Components (%)": "",
          };
        });
        setExcelData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchMasterProducts = async (productName = "") => {
    try {
      const queryParams = new URLSearchParams({
        limit: "100",
        page: "1",
      });
      if (productName?.trim()) {
        queryParams.set("productName", productName.trim());
      }
      const res = await get(`/master/product/getAll?${queryParams.toString()}`);
      setMasterProducts(res?.data?.data || []);
    } catch (error) {
      console.error("Error fetching master products:", error);
      setMasterProducts([]);
    }
  };

  useEffect(() => {
    const term = productSearchTerm.trim();
    const shouldSearch = term.length === 0 || term.length >= 3;
    if (!shouldSearch) return;

    const timer = setTimeout(() => {
      fetchMasterProducts(term);
    }, 700);

    return () => clearTimeout(timer);
  }, [productSearchTerm]);

  const openModal = (type, dataForEdit) => {
    if (type === "add") {
      setProductSearchTerm("");
      fetchMasterProducts("");
      setIsModalOpen(true);
      setEditModal(false);
      setEditData({});
    } else if (type === "edit") {
      setIsModalOpen(true);
      setEditData(dataForEdit);
      setEditModal(true);
      setViewModal(false);
    }
  };

  const handleEdit = (data) => {
    openModal("edit", data);
  };

  const openViewModal = (data) => {
    setEditData(data);
    setViewModal(true);
  };

  const closeModal = (type) => {
    if (type === "add") {
      setIsModalOpen(false);
    } else if (type === "edit") {
      setIsModalOpen(false);
      setEditModal(false);
      setEditData({});
    }
  };

  const handleSubmit = async (data, isEditing) => {
    try {
      const url = isEditing
        ? `/scope3/useOfSoldProducts/update?Id=${editData.id || editData._id}`
        : `/scope3/useOfSoldProducts/add`;

      const apiCall = isEditing ? put : post;

      const resolvedProductIdFromList =
        masterProducts.find(
          (item) =>
            item?._id === data.productMasterId ||
            item?.productId === (data.productIdOrSku || data.productId) ||
            item?.productName === data.productName
        )?._id || "";

      const resolvedProductId =
        data.productMasterId ||
        (isMongoId(data.productIdOrSku) ? data.productIdOrSku : "") ||
        resolvedProductIdFromList ||
        data.productId;

      const matchedMasterProduct =
        masterProducts.find(
          (item) =>
            item?._id === resolvedProductId ||
            item?.productId === (data.productIdOrSku || data.productId) ||
            item?.productName === data.productName
        ) || null;

      if (!isMongoId(resolvedProductId)) {
        setsnackOpen({
          open: true,
          message: "Please select a valid product from the dropdown.",
          severity: "error",
        });
        return;
      }

      const payload = {
        ...data,
        productId: resolvedProductId,
        productName:
          matchedMasterProduct?.productName ||
          matchedMasterProduct?.name ||
          data.productName,
        productIdOrSku:
          matchedMasterProduct?.productId ||
          matchedMasterProduct?.sku ||
          data.productIdOrSku ||
          data.productId,
        unitOfProductSold: {
          value: data.unitOfProductSold,
          unit: data.unitOfProductSoldUnit,
        },
        averageAnnualEnergyConsumptionPerUnit:
          data.averageAnnualEnergyConsumptionPerUnit,
        avgAnnualEnergyConsumptionPerUnit:
          data.averageAnnualEnergyConsumptionPerUnit,
        recyclableComponentsPercentage: data.recyclableComponentsPercentage,
        replacementParts: data.recyclableComponentsPercentage,
        designedForReuseRecyclingDisposal:
          data.designedForReuseRecyclingDisposal,
        isProductDesignedForReuseRecyclingDisposal:
          data.designedForReuseRecyclingDisposal,
      };

      delete payload.unitOfProductSoldUnit;
      delete payload.productIdSku;
      delete payload.productMasterId;
      delete payload.energyTypeRequired;

      const res = await apiCall(url, payload);

      if (res) {
        setsnackOpen({
          open: true,
          message: res?.data?.message,
          severity: "success",
        });

        setIsModalOpen(false);

        if (isEditing) {
          setEditModal(false);
          setEditData({});
        }

        fetchCardData();
        fetchData();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error?.response?.data?.message || "Something went wrong",
        severity: "error",
      });

      console.error("Error in handleSubmit (UseOfSoldProducts):", error);
    }
  };

  const handleDeleteOpen = (row) => {
    setDeletedItemId(row);
    setDeleteDialog(true);
  };

  const handleDeleteAgree = async () => {
    try {
      await del(`/scope3/useOfSoldProducts/delete`, {
        params: {
          Id: deletedItemId?.id || deletedItemId?._id,
        },
      });
      setDeleteDialog(false);
      setsnackOpen({
        open: true,
        message: "Deleted successfully",
        severity: "success",
      });
      fetchData();
      fetchCardData();
    } catch (err) {
      console.error(err);
      setsnackOpen({
        open: true,
        message: err.response?.data?.message ?? "Network Error",
        severity: "error",
      });
    }
  };

  return (
    <>
      <Cards data={bannerData} title={"Use of Sold Products"} />

      <ActionButtons
        onFilterClick={() => setIsFilterModalOpen(true)}
        onAddClick={() => openModal("add")}
        filterObj={filterObj}
        onUploadClick={() => setBulkUploadModal(true)}
      />

      <ViewTable
        title={"Use of Sold Products"}
        editIcon={user?.companyAdmin ? "disable" : "enable"}
        headers={headers}
        data={tableData ?? []}
        onSort={handleSort}
        sortConfig={sortConfig}
        page={currentPage}
        count={10}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onView={(row) => {
          openViewModal(row);
        }}
        onEdit={(row) => openModal("edit", row)}
        onDelete={(row) => handleDeleteOpen(row)}
      />

      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          onClose={() => setsnackOpen({ ...snackOpen, open: false })}
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>

      <Form
        isOpen={isModalOpen}
        onClose={() => closeModal(editModal ? "edit" : "add")}
        onSubmit={handleSubmit}
        header={editModal ? "Edit Use of Sold Product" : "Add Use of Sold Product"}
        initialData={editData}
        isEditing={editModal}
        productOptions={masterProducts}
        onSearchProducts={setProductSearchTerm}
      />

      <ViewData
        id={editData ? editData.id || editData._id : ""}
        element={editData}
        title={"Use of Sold Products"}
        viewData={viewModal}
        setViewData={setViewModal}
        setData={setEditData}
        inputData={inputData}
        handleEdit={handleEdit}
        companyAdmin={user?.companyAdmin}
      />

      {deleteDialog && (
        <DeleteAlertDialog
          {...{
            deleteDialog,
            setDeleteDialog,
            method: "delete",
            id: deletedItemId?.id || deletedItemId?._id,
            url: `${api}/scope3/useOfSoldProducts/delete`,
            setsnackOpen,
            fetchData,
            fetchCardData,
          }}
        />
      )}

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      />

      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          isBulkUploadModal={bulkUploadModal}
          excelData={excelData}
          fileName={"useOfSoldProducts"}
          setsnackOpen={setsnackOpen}
          url={"/scope3/useOfSoldProducts/bulkupload"}
          setMatchData={setMatchData}
          setFormDataBulkUpload={setFormDataBulkUpload}
          matchedKey="productStatusList"
          errorClose={uploadErrorClose}
          setBulkUploadModal={setBulkUploadModal}
        />
      )}

      {bulkUploadTable && (
        <BulkUploadReview
          bulkUploadTable={bulkUploadTable}
          matchData={matchData}
          setMatchData={setMatchData}
          formDataBulkUpload={formDataBulkUpload}
          setFormDataBulkUpload={setFormDataBulkUpload}
          setsnackOpen={setsnackOpen}
          bulkUploadUrl={"/scope3/useOfSoldProducts/jsonupload"}
          onClose={() => setBulkUploadTable(false)}
          onConfirm={(data) => {
            setBulkUploadTable(false);
            setMatchData([]);
            setFormDataBulkUpload([]);
            fetchData();
            fetchCardData();

            const skippedEntries = data?.skippedEntries;
            const hasSkipped =
              Array.isArray(skippedEntries) && skippedEntries.length > 0;
            const inserted = Number(data?.inserted ?? 0);
            const skipped = Number(data?.skipped ?? 0);

            if (hasSkipped) {
              setSkippedUploadDialog({
                open: true,
                skippedEntries,
                inserted,
                skipped,
              });
            }
          }}
        />
      )}

      <BulkUploadSkippedDialog
        open={skippedUploadDialog.open}
        skippedEntries={skippedUploadDialog.skippedEntries}
        inserted={skippedUploadDialog.inserted}
        skipped={skippedUploadDialog.skipped}
        downloadFileName="use_of_sold_products_skipped"
        onClose={() =>
          setSkippedUploadDialog({
            open: false,
            skippedEntries: [],
            inserted: 0,
            skipped: 0,
          })
        }
        // onDownload={(rows) => setExcelData(rows)}
      />
    </>
  );
};

export default UseOfSoldProducts;

